/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Checkbox,
  Collapse,
  FormControlLabel,
  IconButton
} from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useState } from 'react'

import {
  BulkUpdateFeatureFlagInput,
  RoleFeature
} from '../../types/featureFlag'
import useStyles from './styles/featureBox.styles'

type Props = {
  featuresGroup: RoleFeature
  bulkUpdateFeatureFlagInput: BulkUpdateFeatureFlagInput
  setBulkUpdateFeatureFlagInput: React.Dispatch<
    React.SetStateAction<BulkUpdateFeatureFlagInput>
  >
}

export default function FeatureBox({
  featuresGroup,
  bulkUpdateFeatureFlagInput,
  setBulkUpdateFeatureFlagInput
}: Props) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const allChecked = featuresGroup.features.every((f) =>
    bulkUpdateFeatureFlagInput?.featureIDs.includes(f.featureID)
  )
  const noneChecked = featuresGroup.features.every(
    (f) => !bulkUpdateFeatureFlagInput?.featureIDs.includes(f.featureID)
  )
  const handleSelectAll = (checked: boolean) => {
    setBulkUpdateFeatureFlagInput((prev) => {
      const groupFeatureIDs = featuresGroup.features.map((f) => f.featureID)
      return {
        ...prev,
        featureIDs: checked
          ? Array.from(new Set([...prev.featureIDs, ...groupFeatureIDs]))
          : prev.featureIDs.filter((id) => !groupFeatureIDs.includes(id))
      }
    })
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <FormControlLabel
          label={featuresGroup.featureGroup}
          control={
            <Checkbox
              checked={allChecked}
              onChange={(e) => handleSelectAll(e.target.checked)}
              indeterminate={!allChecked && !noneChecked}
              color="primary"
              size="small"
            />
          }
        />
      </div>
      <Collapse in={open}>
        <div className={classes.body}>
          {featuresGroup.features.map((feature) => (
            <div key={feature.featureID} className={classes.subItem}>
              <FormControlLabel
                label={feature.name}
                control={
                  <Checkbox
                    checked={
                      !!bulkUpdateFeatureFlagInput?.featureIDs.includes(
                        feature.featureID
                      )
                    }
                    onChange={(e) => {
                      const checked = e.target.checked
                      setBulkUpdateFeatureFlagInput((prev) => {
                        if (!prev) return prev

                        const exists = prev.featureIDs.includes(
                          feature.featureID
                        )
                        return {
                          ...prev,
                          featureIDs: checked
                            ? exists
                              ? prev.featureIDs
                              : [...prev.featureIDs, feature.featureID]
                            : prev.featureIDs.filter(
                                (id) => id !== feature.featureID
                              )
                        }
                      })
                    }}
                    color="primary"
                    size="small"
                    onClick={(e) => e.stopPropagation()}
                  />
                }
              />
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  )
}
